import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const Empty = () => {
    return (
        <tr className={classes.EmptyRow}>
            <td colSpan="5">
                <div className={classes.Empty}>
                    <h5>
                        <FormattedMessage id="TransactionsTable.empty" defaultMessage="Платежей нет"/>
                    </h5>
                </div>
            </td>
        </tr>
    );
};

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/TransactionsTable/Empty.js